import {MenuItem, Text, Viewer} from 'bigdatr-style';
import {Box, FlexColumn, Grid} from 'bigdatr-style/layout';
import React from 'react';
import {Users} from 'react-swm-icon-pack';
import {useQueryClient} from '@tanstack/react-query';

export default function DropdownSwitchTeams(props: {
    viewer: Viewer;
    changeTeam: (teamId: string) => void;
}) {
    const {viewer, changeTeam} = props;
    const queryClient = useQueryClient();

    const teamsToRender = viewer.teamsWithAccess.filter((team) => team.id !== viewer.currentTeamId);

    const loggedInAsInfo = (
        <Box px={2} pb={2} fontSize={1} borderBottom="outline">
            Logged in as {viewer.user.username}
        </Box>
    );

    if (teamsToRender.length === 0) return <Box pt={2}>{loggedInAsInfo}</Box>;

    const onChangeTeam = (teamID: string) => {
        // we invalidate the cache so that it will refresh all the data when changing teams
        queryClient.clear();
        changeTeam(teamID);
    };

    return (
        <FlexColumn pt={2} borderBottom="outline">
            <FlexColumn gap={2}>
                {loggedInAsInfo}
                <Text px={2} fontSize={1} textStyle="strong">
                    Switch to another team
                </Text>
            </FlexColumn>
            {teamsToRender.map((team) => (
                <MenuItem px={2} key={team.id} onClick={() => onChangeTeam(team.id)}>
                    <Grid gridTemplateColumns="1rem auto" gap={2} alignItems="center">
                        <Users size="16" />
                        {team.name}
                    </Grid>
                </MenuItem>
            ))}
        </FlexColumn>
    );
}
